import { http, httpFile } from './http_service';


//Get List cars with - Pagination
export function listPage(obj){
    let params = {
        page:obj.page, 
        recordsPerPage:obj.recordsPerPage, 
        q:obj.q, 
        selectedStatus:obj.selectedStatus, 
        sort_direction:obj.sort_direction, 
        sort_field:obj.sort_field
    }
    return http().get(`/car-category/list-page`, {
        params:params
    });
}

//Get Single
export function single(id){
    return http().get(`/car-category/${id}`);
}
//Add one
export function add(data){
    return http().post('/car-category/add', data)
}
//Update
export function update(id, data){
    return http().put(`/car-category/update/${id}`, data)
}
//dropdown
export function dropdown(){
    return http().get(`/car-category/dropdown`)
}


